import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputReusable } from '../input-reusable/input-reusable';

@Component({
	selector: 'app-interview-question-block',
	standalone: true,
	imports: [CommonModule, InputReusable],
	templateUrl: './interview-question-block.html',
	styles: [
		`
			:host ::ng-deep .question-input input,
			:host ::ng-deep .question-input textarea {
				background-color: #eef2ff;
				border-color: #a5b4fc;
			}
		`,
	],
})
export class InterviewQuestionBlock {
	@Input() questionLabel = 'Question';
	@Input() required = false;
	@Input() questionReadonly = true;
	@Input() questionControl = new FormControl<string>('', { nonNullable: true });

	@Input() commentLabel = 'Comments';
	@Input() commentPlaceholder: string | undefined =
		'Capture key response, example and assessment of the applicant....';
	@Input() commentControl = new FormControl<string>('', { nonNullable: true });
	@Input() maxCommentLength = 500;

	get commentCount(): number {
		return this.commentControl?.value?.length ?? 0;
	}
}
